module.exports = __webpack_public_path__ + "media/assets/icons/pinned-room-c3624b6bc2179b200da6f38b4e9e9fa9.png";